export default "__VITE_ASSET__3f248441__"